var _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_21_1127",
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: -1,
    width: 13,
    height: 12,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -3,
    y: -1,
    width: 13,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4 9.34L4.88 4.82L0.4 0.319999H3.62L8.1 4.82L3.62 9.34H0.4Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.4 9.34L4.88 4.82L0.4 0.319999H3.62L8.1 4.82L3.62 9.34H0.4Z",
    fill: "#171718"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.4 9.34L-0.310242 8.63604L-1.99912 10.34H0.4V9.34ZM4.88 4.82L5.59024 5.52396L6.28952 4.81844L5.58868 4.11447L4.88 4.82ZM0.4 0.319999V-0.680001H-2.00663L-0.30868 1.02553L0.4 0.319999ZM3.62 0.319999L4.32868 -0.385531L4.03552 -0.680001H3.62V0.319999ZM8.1 4.82L8.81024 5.52396L9.50952 4.81844L8.80868 4.11447L8.1 4.82ZM3.62 9.34V10.34H4.03682L4.33024 10.044L3.62 9.34ZM1.11024 10.044L5.59024 5.52396L4.16976 4.11604L-0.310242 8.63604L1.11024 10.044ZM5.58868 4.11447L1.10868 -0.385531L-0.30868 1.02553L4.17132 5.52553L5.58868 4.11447ZM0.4 1.32H3.62V-0.680001H0.4V1.32ZM2.91132 1.02553L7.39132 5.52553L8.80868 4.11447L4.32868 -0.385531L2.91132 1.02553ZM7.38976 4.11604L2.90976 8.63604L4.33024 10.044L8.81024 5.52396L7.38976 4.11604ZM3.62 8.34H0.4V10.34H3.62V8.34Z",
    fill: "#ACD1D1",
    mask: "url(#path-1-outside-1_21_1127)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevRight);
export default __webpack_public_path__ + "static/media/chevRight.e4d7416e1c8e0dc23504ffecec65f103.svg";
export { ForwardRef as ReactComponent };